
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalCharging25 as ObiBatteryHorizontalCharging25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-charging-25.js';
 
 
 

 
 export const ObiBatteryHorizontalCharging25 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-charging-25',
   elementClass: ObiBatteryHorizontalCharging25Element,
   events: {
     
   }
  });
 
 